import { render, staticRenderFns } from "./ReminderDaysForm.vue?vue&type=template&id=746c986e&scoped=true"
import script from "./ReminderDaysForm.vue?vue&type=script&lang=js"
export * from "./ReminderDaysForm.vue?vue&type=script&lang=js"
import style0 from "./ReminderDaysForm.vue?vue&type=style&index=0&id=746c986e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746c986e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('746c986e')) {
      api.createRecord('746c986e', component.options)
    } else {
      api.reload('746c986e', component.options)
    }
    module.hot.accept("./ReminderDaysForm.vue?vue&type=template&id=746c986e&scoped=true", function () {
      api.rerender('746c986e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DeviceAnnualInspection/ReminderDaysForm.vue"
export default component.exports